export default __webpack_public_path__ + "static/media/passion-fruit-mojito-recipe-photo-1.9b6ced6b.jpeg";